module.exports = __webpack_public_path__ + "static/img/02@2x.23d6b81c.png";